import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import './App.css';
import Home from './pages/Home';
import Videos from './pages/Videos';
import Services from './pages/Services';
import Booking from './pages/Booking';
import Addons from './pages/Addons'
import Bio from './pages/Bio';
import Projects from './pages/Projects';
import Policies from './pages/Policies';
import Contact from './pages/Contact';

function App() {
  return (
    <Router>
      <Navbar />
      <Switch>
        <Route path='/' exact component={Home} />
        <Route path='/services' exact component={Services} />
        <Route path='/booking' exact component={Booking} />
        <Route path='/addons' exact component={Addons} />
        <Route path="/about" element component={Bio} />
        <Route path='/projects' exact component={Projects} />
        <Route path='/videos' exact component={Videos} />
        <Route path='/contact' exact component={Contact} />
        <Route path='/policies' exact component={Policies} />
      </Switch>
    </Router>
  );
}

export default App;